export default __webpack_public_path__ + "static/media/Group 3367.d0862ad3.png";